import { render, staticRenderFns } from "./ProcurementVendor.vue?vue&type=template&id=545c7cf2"
import script from "./ProcurementVendor.vue?vue&type=script&lang=js"
export * from "./ProcurementVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports